@app.directive 'matrixItemMedia', (matrixItemService) ->
  restrict: 'E'
  scope: {}
  controller: ->
    @isRecipe = matrixItemService.isRecipe

    this
  controllerAs: 'matrixItemMedia'
  templateUrl: "/assets/templates/components/matrix/matrixItem/matrixItemMedia/matrixItemMedia.html"
  bindToController: {
    content: '='
    descriptionCharLimit: '='
    showLikes: '='
    loadImageOnEnterViewport: '='
    track: '&'
  }
